import type {SVGProps} from 'react'
const SvgThumbDownLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#788492"
      d="M7.5 3h9v9.869l-1.956 3.042-.543 3.944a1.36 1.36 0 0 1-.432.818c-.234.21-.532.326-.841.327h-.085a1.9 1.9 0 0 1-1.363-.586A2.04 2.04 0 0 1 10.714 19v-4H5.571a2.53 2.53 0 0 1-1.817-.782A2.72 2.72 0 0 1 3 12.333V7.667a4.76 4.76 0 0 1 1.32-3.299A4.43 4.43 0 0 1 7.5 3ZM21 12.5a1 1 0 0 1-1 1h-3.5V3H20a1 1 0 0 1 1 1z"
    />
  </svg>
)
export default SvgThumbDownLarge
